import React, { memo, useEffect, useState } from 'react';
import { setPayload } from '../../../redux/reducer/payload';
import { useAppDispatch, useAppSelector } from '../../../redux/app';
import { EXPIRATION } from '../../../constants/expireation';
import moment from 'moment';
const Expiration = memo(() => {
  const payload = useAppSelector((state) => state.payload?.payload);
  const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);

  const handleChageExpiration = (value) => {
    switch (value) {
      case 0:
        dispatch(setPayload({ ...payload, type_time: value, time_expiration: 0 }));
        break;
      case 1:
        dispatch(
          setPayload({
            ...payload,
            type_time: value,
            time_expiration: moment.tz('Europe/London').isDST()
              ? moment().utc().unix() + 3600
              : moment().utc().unix()
          })
        );
        break;
      case 2:
        dispatch(
          setPayload({
            ...payload,
            type_time: value,
            time_expiration: moment.tz('Europe/London').isDST()
              ? moment().utc().unix() + 3600
              : moment().utc().unix()
          })
        );
        break;
      case 3:
        dispatch(
          setPayload({
            ...payload,
            type_time: value,
            time_expiration: moment.tz('Europe/London').isDST()
              ? moment().utc().unix() + 3600
              : moment().utc().unix()
          })
        );
        break;
      default:
        break;
    }
  };

  return (
    <div className="flex flex-col relative w-full">
      <div
        className="cursor-pointer"
        onMouseEnter={e => {
          e.currentTarget.style.borderColor = '#0FEF9E'
        }}
        onMouseLeave={e => {
          e.currentTarget.style.borderColor = open ? '#0FEF9E' : '#4B4B4B'
        }}
        style={{
          borderColor: open ? '#0FEF9E' : '#4B4B4B',
          borderStyle: 'solid',
          borderWidth: '1px',
          borderRadius: '8px'
        }}
      >
        <div
          className="select-expire h-[40px] flex items-center justify-between px-3 rounded-lg"
          onClick={() => setOpen(!open)}>
          <div className="text-[#9f9f9f] text-sm">
            {EXPIRATION.find((e) => e.value === payload.type_time)?.label}
          </div>
          <div>
            <svg
              className={`transition-all ${open ? 'rotate-0' : 'rotate-180'} history-btn-action`}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                {' '}
                <path
                  d="M18.2929 15.2893C18.6834 14.8988 18.6834 14.2656 18.2929 13.8751L13.4007 8.98766C12.6195 8.20726 11.3537 8.20757 10.5729 8.98835L5.68257 13.8787C5.29205 14.2692 5.29205 14.9024 5.68257 15.2929C6.0731 15.6835 6.70626 15.6835 7.09679 15.2929L11.2824 11.1073C11.673 10.7168 12.3061 10.7168 12.6966 11.1073L16.8787 15.2893C17.2692 15.6798 17.9024 15.6798 18.2929 15.2893Z"
                  fill="#9f9f9f"></path>{' '}
              </g>
            </svg>
          </div>
        </div>
      </div>
      {open && (
        <div
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          className="absolute z-10 top-[48px] left-0 bg-[#202020] border border-[#80808059] w-full flex flex-col rounded-md">
          {EXPIRATION.map((e, i) => (
            <div
              onClick={() => {
                setOpen(false);
                handleChageExpiration(e.value);
              }}
              key={e.value}
              className="text-[#e5e5e5] text-sm px-4 h-[30px] flex items-center hover:bg-[#404040] transition-all cursor-pointer">
              {e.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
});
Expiration.displayName = 'Expiration';

export default Expiration;
